import CourseDropdown from "../../../Common/Component/CourseDropdown"
import { Btn, Dropdowns } from "../../../AbstractElements"
import { feeModules } from "../../../Data"
import { CardBody } from "reactstrap"
import SeachBar from "../../UiKits/SearchBar"
import { Table } from "antd"
import { getFeeDataColumn } from "../../../utils/feeColumn"
import { toast } from "react-toastify"
import { useContext } from "react"
import courseContext from "../../../Helper/Courses"
import { printPdf } from "../../../utils/printPdf"
import { composeEmail } from "../../Pages/UsersMangement/EmailHandler"


const FeeTableHeader = ({ module, setModule, search, setSearch, feeStatus, courseStudents, feeAmount, setFeeAmount }) => {
  const { activeCourse } = useContext(courseContext)
  const emailOptions = [
    { item: 'Email All', onClick: () => composeEmail('all', courseStudents) },
    { item: 'Email All Verified only', onClick: () => composeEmail('verified', courseStudents, module) },
    { item: 'Email All Unverified only', onClick: () => composeEmail("notVerified", courseStudents, module) },
    { item: 'Email All Pending only', onClick: () => composeEmail("pending", courseStudents, module) },
    { item: 'Email All Unpiad only', onClick: () => composeEmail("unpaid", courseStudents, module) }
  ]

  const downloadOptions = [
    {
      item: 'All Verified Students', onClick: () => printPdf(
        courseStudents,
        activeCourse,
        module,
        true,
        feeStatus
      )
    },
    {
      item: 'All Verified Students', onClick: () => printPdf(
        courseStudents,
        activeCourse,
        module,
        false,
        feeStatus
      )
    }
  ]

  const moduleClickHandler = ({ target: { innerText } }) => {
    if (innerText === feeModules[module].item) return
    setModule(feeModules.findIndex((fee) => fee.item === innerText))
  }

  return (
    <>
      <div className='fee-table-header'>
        <div className="header-row">
          <CourseDropdown selectCourse={activeCourse?.id} />
          <SeachBar search={search} setSearch={setSearch} />
        </div>
        <div className="fee-data ant-design-table not-margin">
          <Table
            columns={getFeeDataColumn()}
            bordered={true}
            pagination={false}
            scroll={{ x: "auto" }}
            loading={!Object.keys(feeStatus).length}
            dataSource={[feeStatus]} />
        </div>
        <div className="header-row m-t-20">
        <div className="dropdown-basic p-0">
            <Dropdowns
              attrDropBtn={{ className: 'module-btn show-color' }}
              attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
              dropItem={feeModules}
              dropBtnContent={<> {feeModules[module].item} <i className="icofont icofont-arrow-down"></i></>}
              attrDropItem={{
                toggle: false,
                onClick: moduleClickHandler
              }}
            />
          </div>
          <div className="dropdown-basic p-0">
            <Dropdowns
              attrDropBtn={{ className: 'module-btn show-color' }}
              attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
              dropItem={emailOptions}
              dropBtnContent={<> Send Emails <i className="icofont icofont-arrow-down"></i></>}
              attrDropItem={{
                toggle: false,
              }}
            />
          </div>
          <div className="dropdown-basic p-0">
            <Dropdowns
              attrDropBtn={{ className: 'module-btn show-color' }}
              attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
              dropItem={downloadOptions}
              dropBtnContent={<> Download PDF <i className="icofont icofont-arrow-down"></i></>}
              attrDropItem={{
                toggle: false,
              }}
            />
          </div>
          <div>
          <Btn attrBtn={{
            onClick: () => setFeeAmount(!feeAmount),
            color: "primary",
            className: "w-100"
          }}>
            {feeAmount ? 'Close fee Amount' : 'Extract Fee Amount'}
          </Btn>
          </div>
        </div>
      </div>
    </>
  )
}

export default FeeTableHeader